
/**
 * Size Guide Toggle Functionality
 * Handles toggling between imperial and metric measurements in the size guide
 */
  // Initialize size guide toggle
  initSizeGuideToggle();

  function initSizeGuideToggle() {
    const sizeGuide = document.querySelector('.SizeGuide');
    if (!sizeGuide) return;
  
    const flipButton = sizeGuide.querySelector('.SizeGuide__Measurements__Flip');
    if (!flipButton) return;
    
    // Set initial state based on locale
    const isUS = isUnitedStates();
    
    // If NOT US, set flip to active by default to show metric
    if (!isUS) {
      const flipElement = flipButton.querySelector('.flip') || flipButton;
      flipElement.classList.add('active');
    }
    
    updateMeasurementVisibility();
    
    // Check if we need to show the toggle button
    const hasImperial = !!document.querySelectorAll('.SizeGuide__BagReference [data-imperial]:not(:empty)').length;
    const hasMetric = !!document.querySelectorAll('.SizeGuide__BagReference [data-metric]:not(:empty)').length;
    
    // Hide flip button if no measurements or only one type exists
    if (!hasImperial || !hasMetric) {
      flipButton.style.display = 'none';
    } else {
      // Add click event listener to toggle
      flipButton.addEventListener('click', function() {
        const flipElement = this.querySelector('.flip') || this;
        flipElement.classList.toggle('active');
        updateMeasurementVisibility();
      });
    }
  }
  
  function updateMeasurementVisibility() {
    const sizeGuide = document.querySelector('.SizeGuide');
    if (!sizeGuide) return;
    
    const flipButton = sizeGuide.querySelector('.SizeGuide__Measurements__Flip');
    if (!flipButton) return;
    
    const flipElement = flipButton.querySelector('.flip') || flipButton;
    const isShowingMetric = flipElement.classList.contains('active');
    const isUS = isUnitedStates();
    
    // For non-US locations, we want metric by default, but respect user toggle
    // The toggle state (isShowingMetric) takes precedence over the locale
    const showMetric = isShowingMetric;
    
    const imperialElements = sizeGuide.querySelectorAll('[data-imperial]');
    const metricElements = sizeGuide.querySelectorAll('[data-metric]');
    
    imperialElements.forEach(el => {
      el.style.display = showMetric ? 'none' : 'block';
    });
    
    metricElements.forEach(el => {
      el.style.display = showMetric ? 'block' : 'none';
    });
  }
  
  function isUnitedStates() {
    const locale = document.querySelector('.SizeGuide__Content')?.getAttribute('data-locale') || '';
    return locale.includes('US');
  }
  